import set from 'lodash/fp/set'
import { isFilterByUserInput } from '../business-logic/filter/transform'
import { isFilterComponentConnectable } from '../business-logic/filter/filterByUserInput'

const removeDisconnectedDatasetFilters = async ({ controllerRef, appApi }) => {
  const dataset = await appApi.fetchDataset(controllerRef)
  const cleanedFilters = dataset.config.filters.filter(
    f => !isFilterByUserInput(f) || isFilterComponentConnectable(f),
  )
  if (cleanedFilters.length !== dataset.config.filters.length) {
    const cleanedConfig = set('filters', cleanedFilters, dataset.config)
    await appApi.updateDatasetConfig(controllerRef, cleanedConfig)
  }
}

export default removeDisconnectedDatasetFilters
